import VoteInput from './VoteInput';

export default VoteInput;
